var render = function render(){var _vm=this,_c=_vm._self._c;return _c('label',{staticClass:"label label-md label-inline text-capitalize w-100",class:`label-light-${_vm.homeStatus2Color(_vm.value)}`},[_vm._v(" "+_vm._s(_vm.value)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }